import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "../DashboardCalenderPages/Calender.css";
import moment from "moment";
import axiosClient from "../../axios-client";
import { useSelector } from "react-redux";

const CustomerAvaliableCalander = ({
  reserveDate,
  startTime,
  setReserveDate,
  setStartTime,
  availableDays,
  ownerId,
}) => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [blockedMeetings, setBlockedMeetings] = useState([]);

  const initializeReserveDate = (date) => {
    const parsedDate = new Date(date);
    return isNaN(parsedDate.getTime()) ? new Date() : parsedDate;
  };

  const [internalReserveDate, setInternalReserveDate] = useState(() =>
    initializeReserveDate(reserveDate)
  );

  const handleDateChange = (date) => {
    setInternalReserveDate(date);
    setReserveDate(moment(date).format("YYYY-MM-DD")); // Format reserveDate as YYYY-MM-DD
  };

  const handleHourChange = (hour, minute) => {
    setStartTime(
      `${hour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")}`
    );
  };

  const preprocessBlockedMeetings = (blockedMeetings) => {
    const blockedTimeRanges = [];
    blockedMeetings.forEach((meeting) => {
      const { reserve_date, start_time, end_time } = meeting;

      if (!start_time) return;

      const meetingStartMoment = moment(`${reserve_date} ${start_time}`);
      const meetingEndMoment = end_time
        ? moment(`${reserve_date} ${end_time}`)
        : moment(meetingStartMoment).add(30, "minutes"); // Default end time if not provided

      blockedTimeRanges.push({
        start: meetingStartMoment,
        end: meetingEndMoment,
      });
    });

    return blockedTimeRanges;
  };

  const isSlotBlocked = (slotTime, blockedTimeRanges) => {
    return blockedTimeRanges.some((range) => {
      return (
        slotTime.isSameOrAfter(range.start) && slotTime.isBefore(range.end)
      );
    });
  };

  useEffect(() => {
    setStartTime("");
  }, [reserveDate]);

const generateHourSlots = () => {
    const slots = [];
    const now = moment(); // Current time: June 17, 2025, 02:34 PM IST
    const selectedDate = moment(internalReserveDate); // Selected date in local timezone
    const isToday = now.isSame(selectedDate, "day");
    const blockedTimeRanges = preprocessBlockedMeetings(blockedMeetings);
    const currentDay = selectedDate.format("dddd");

    // Check if the selected date is in the available days
    const availableDay = availableDays?.find((available) => 
        available?.days.includes(currentDay)
    );

    // Define the default range: 8:00 AM to 9:00 PM
    const defaultStartHour = 8; // 8:00 AM
    const defaultEndHour = 21; // 9:00 PM
    const defaultStartMinutes = defaultStartHour * 60; // 480 minutes
    const defaultEndMinutes = defaultEndHour * 60; // 1260 minutes

    if (availableDay) {
        const [startHour, startMinute] = availableDay.from.split(":").map(Number);
        const [endHour, endMinute] = availableDay.to.split(":").map(Number);

        // Convert start and end times to minutes for easier comparison
        const startTimeMinutes = startHour * 60 + startMinute; // e.g., 8:40 AM = 520 minutes
        const endTimeMinutes = endHour * 60 + endMinute; // e.g., 10:00 PM = 1320 minutes

        // Find the first slot before 'from' that aligns with 30-minute intervals starting from 8:00 AM
        const interval = 30; // 30-minute gap
        let firstSlotMinutes = startTimeMinutes;
        while (firstSlotMinutes > defaultStartMinutes) {
            firstSlotMinutes -= interval;
        }
        // Adjust if the first slot is exactly 8:00 AM to ensure proper alignment
        if (firstSlotMinutes < defaultStartMinutes) {
            firstSlotMinutes += interval; // Start from the first slot after 8:00 AM
        }

        // Determine the actual end minutes (either 9:00 PM or 'to' time if later)
        const actualEndMinutes = Math.max(defaultEndMinutes, endTimeMinutes);

        // Generate slots from the first aligned slot to the end time
        let currentMinutes = firstSlotMinutes;
        while (currentMinutes <= actualEndMinutes) {
            const i = Math.floor(currentMinutes / 60); // Hour
            const j = currentMinutes % 60; // Minute

            let formattedHour;
            let period;

            if (i < 12) {
                formattedHour = i === 0 ? "12" : `${i}`;
                period = "AM";
            } else {
                formattedHour = i === 12 ? "12" : `${i - 12}`;
                period = "PM";
            }

            let startendblocked = "";
            const isSelected =
                parseInt(startTime.split(":")[0]) === i &&
                parseInt(startTime.split(":")[1]) === j;

            // Create slotTime in local time zone
            const slotTime = moment(selectedDate).set({
                hour: i,
                minute: j,
                second: 0,
                millisecond: 0,
            });

            // Check if the slot is within the available time range (from-to)
            const isAvailable = availableDay.days.includes(currentDay) && 
                currentMinutes >= startTimeMinutes && 
                (currentMinutes < endTimeMinutes || 
                 (currentMinutes === endTimeMinutes && endMinute === 0));

            // Check if the slot is the 'from' or 'to' slot
            const isFromSlot = currentMinutes === startTimeMinutes;
            const isToSlot = currentMinutes === endTimeMinutes;

            const isCompleted = isToday && slotTime.isBefore(now);
            const isBlocked = isSlotBlocked(slotTime, blockedTimeRanges);

            // Include slots that are not completed or blocked for availability
            if (!isCompleted && !isBlocked) {
                slots.push(
                    <div
                        key={`${i}:${j}`}
                        className="hour-slot-container tw"
                    >
                        <div
                            className={`${startendblocked} hour-slot ${
                                isSelected ? "selected" : ""
                            } ${
                                isFromSlot || isToSlot 
                                    ? "not-preferred-slot" 
                                    : isAvailable 
                                    ? "available" 
                                    : "not-available"
                            } ${i === now.hour() && j === 0 ? "focus" : ""}`}
                            onClick={() =>
                                !isCompleted &&
                                !isBlocked &&
                                handleHourChange(i, j)
                            }
                        >
                            <div className="flex items-center justify-center">
                                <span>
                                    {formattedHour.padStart(2, "0")}:{j.toString().padStart(2, "0")}{" "}
                                    {period}
                                </span>
                                {isAvailable && (
                                  <span className={`ml-1 ${isSelected ? "text-white" : "text-orange-500"}`}>★</span>
                                )}
                            </div>
                        </div>
                    </div>
                );
            }

            currentMinutes += interval; // Increment by 30 minutes
        }
    }

    // If no slots are available, return a message
    if (slots.length === 0) {
        return (
           <div className="tw flex items-center justify-center min-h-[200px]">
    <div className="  bg-gray-50 border border-gray-200 rounded-lg shadow-sm p-6 text-center max-w-sm">
        <p className="  text-gray-600 text-lg font-medium">
            No Available Slots
        </p>
        <p className="  text-gray-500 text-xs mt-2">
            Please select a different date or check back later.
        </p>
    </div>
</div>
        );
    }
    return slots;
};

  useEffect(() => {
    const fetchBlockedMeetings = async () => {
      try {
        const response = await axiosClient.get(
          `order/BlockCalanderDetailMsg/${ownerId}`
        );
        const data = response.data.Data;

        // Filter only today's and future blocked meetings
        const now = moment(); // Current time in local timezone
        const today = moment().startOf("day"); // Start of today

        const todayAndFutureBlockedMeetings = data.filter((meeting) => {
          const meetingDate = moment(meeting.reserve_date);
          if (meetingDate.isBefore(today, "day")) return false; // Skip past dates

          const meetingStartMoment = moment(
            `${meeting.reserve_date} ${meeting.start_time}`
          );
          return meetingStartMoment.isSameOrAfter(now); // Include only future meetings
        });

        setBlockedMeetings(todayAndFutureBlockedMeetings);
      } catch (error) {
        console.error(error);
      }
    };

    fetchBlockedMeetings();
  }, [ownerId]);

  // const tileClassName = ({ date, view }) => {
  //   const currentDate = new Date();
  //   currentDate.setHours(0, 0, 0, 0); // Set current date to midnight for comparison
  //   if (view === "month" && date.getTime() === internalReserveDate.getTime()) {
  //     return "selected-date";
  //   }
  //   return date < currentDate ? "completed-date" : null;
  // };

  const tileClassName = ({ date, view }) => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Set current date to midnight for comparison
    const currentDay = moment(date).format("dddd"); // Get the day of the week

    // Check if the date is in the available days
    const isAvailableDay = availableDays?.some((available) => 
        available?.days.includes(currentDay)
    );

    // Current date and time: June 17, 2025, 12:03 PM IST
    const today = moment(); // Today: June 17, 2025, 12:03 PM
    const startOfToday = moment(today).startOf("day"); // Start of today (June 17, 00:00)

    // Check if the date is on or after today (including current week and upcoming weeks)
    const isOnOrAfterToday = moment(date).isSameOrAfter(startOfToday, "day");

    if (view === "month") {
        // Check if the date matches the selected date (clicked date)
        if (date.getTime() === internalReserveDate.getTime()) {
            return "selected-date tw bg-blue-600 text-white"; // Dark blue for selected date
        }
        // Check if the date is an available day and on or after today
        if (isAvailableDay && isOnOrAfterToday) {
            return "available-day-upcoming tw bg-green-500 text-white"; // Green background for available days from today onward
        }
        // Check if the date is an available day (before today)
        if (isAvailableDay) {
            return "available-day"; // Light blue for available days before today
        }
        // Mark past dates as completed
        return date < currentDate ? "completed-date tw   text-gray-600" : null;
    }
    return null;
};

  var date = new Date();
  date.setDate(date.getDate() - 1);

  return (
    <div className="google-calendar tw">
      <div className="calendar-container">
        <div className="date-picker">
          <Calendar
            onChange={handleDateChange}
            value={internalReserveDate}
            tileClassName={tileClassName}
            minDate={date}
          />
        </div>
        <div className="time-slot">
          <div className="hour-slots">{generateHourSlots()}</div>
        </div>
        <div></div>
      </div>
     <div className="d-flex justify-content-end mx-5">
    <div
        className="d-flex my-3 justify-content-evenly align-items-center"
        style={{ gap: "8px", fontSize: "10px" }}
    >
        {/* Available Indicator */}
        <div
            style={{
                padding: "5px",
                backgroundColor: "#e7eef9", // Light blue for available slots
                borderRadius: "50%",
                height: "20px",
                width: "20px",
            }}
        ></div>
        <span>Available</span>

        {/* Not Available Indicator (Commented Out) */}
        {/* <div
            style={{
                padding: "5px",
                backgroundColor: "#d4d4d4",  
                borderRadius: "50%",
                height: "20px",
                width: "20px",
            }}
        ></div>
        <span>Not available</span> */}

        {/* Selected Hour Indicator */}
        <div
            style={{
                padding: "5px",
                backgroundColor: "#53ae3e", // Green for selected hour
                borderRadius: "50%",
                height: "20px",
                width: "20px",
            }}
        ></div>
        <span>Selected Hour</span>

        {/* Preferred Slot Indicator */}
        <div
            style={{
                backgroundColor: "#f0f0f0", // Dark blue (matches bg-blue-600) for preferred slots
                borderRadius: "50%",
                height: "20px",
                width: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#f97316", // Orange (text-orange-500) for the star
                fontSize: "20px", // Adjusted font size to fit the star
            }}
        >
            ★
        </div>
        <span>Preferred slot</span>
    </div>
</div>
    </div>
  );
};

export default CustomerAvaliableCalander;
